import GamePage from "../../components/GameSelect/GamePage";

const Fish = () => {
  return <GamePage platformType={`FH`} specialColor={`#0B77C4`} />;
};

export default Fish;
